import { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import Menu from '../sections/Menu';
import Footer from '../sections/Footer';
import PageMeta from '../seo/PageMeta';

export default function BlogLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();
  const redirectTarget = new URLSearchParams(location.search).get('redirect') || '/blog';

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate(redirectTarget);
    } catch (error) {
      alert('Błąd logowania: ' + error.message);
    }
  };

  return (
    <>
      <PageMeta path="/login/blog" />
      <Menu />
      <main style={{ padding: '2rem' }}>
        <h1>Zaloguj się na bloga</h1>
        <form onSubmit={handleLogin} style={{ maxWidth: 400 }}>
          <input
            className='login-input'
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <br />
          <input
            className='login-input'
            type="password"
            placeholder="Hasło"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          <br />
          <button className='login button-default btn' type="submit">Zaloguj</button>
        </form>
      </main>
      <Footer />
    </>
  );
}
